module.exports = __webpack_public_path__ + "img/5e4e215.jpg";